import React from 'react'
import classNames from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { ImgSanity } from '@slite/components'

import { Section } from '../../components/Section'
import { getAiSearchUseCases } from './data'

const CARD_BORDER = '1px solid var(--alpha-shade-40)'
const CARD_MAX_HEIGHT = 500

export function SectionAiSearchUseCases() {
  const intl = useIntl()
  const useCases = getAiSearchUseCases(intl)

  return (
    <Section
      containerVerticalPadding={120}
      background="moon-dust-lighter"
      className="position-relative"
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 800 }}
      >
        <h2
          className="font-family-title font-size-2 line-height-normal font-weight-medium shade-05"
          style={{ letterSpacing: '-0.02em' }}
        >
          <FormattedMessage
            id="aiSearch.usecases.title"
            defaultMessage="One company brain. Every team’s job, faster."
          />
        </h2>
        <p
          className="font-size-4 line-height-large margin-top-16 shade-10"
          style={{ maxWidth: 640 }}
        >
          <FormattedMessage
            id="aiSearch.usecases.subtitle"
            defaultMessage="From sales calls to onboarding, Slite's AI search finds the right answer where your team already works."
          />
        </p>
      </div>

      <div
        className="margin-top-40 flexbox flexbox-column flexbox-gap-16 margin-left-auto margin-right-auto"
        style={{ maxWidth: 1100 }}
      >
        {useCases.map((uc) => (
          <div
            key={uc.key}
            className="grid-12 grid-gap-24 background-shade-100 radius-larger"
            style={{
              border: CARD_BORDER,
              overflow: 'hidden',
              maxHeight: CARD_MAX_HEIGHT,
            }}
          >
            <div
              className="grid-span-5-large grid-span-6-medium grid-span-12-small flexbox flexbox-column flexbox-space-between padding-40"
              style={{ minHeight: CARD_MAX_HEIGHT, paddingRight: 40 }}
            >
              <div className="font-size-7 font-weight-semibold shade-20 letter-spacing-large">
                {uc.label.toUpperCase()}
              </div>
              <div>
                <div className="font-family-title font-size-3 font-weight-medium line-height-title shade-05">
                  {uc.title}
                </div>
                <div className="font-size-5 line-height-large shade-20 margin-top-12">
                  {uc.desc}
                </div>
              </div>
            </div>
            <div
              className="grid-span-7-large grid-span-6-medium grid-span-12-small position-relative"
              style={{
                maxHeight: CARD_MAX_HEIGHT,
                overflow: 'hidden',
              }}
            >
              <ImgSanity
                src={uc.image}
                alt={uc.title}
                className="width-full"
                style={{
                  display: 'block',
                  objectFit: 'cover',
                  objectPosition: 'left top',
                  height: '100%',
                  maxHeight: CARD_MAX_HEIGHT,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </Section>
  )
}
